import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
const ActionBtns = ({ onView, onEdit, onDelete }) => (
  <div style={{ display:'flex', gap:3 }}>
    {onView   && <button style={{ ...S.btnGhost, color:C.primary }} title="View"   onClick={e=>{ e.stopPropagation(); onView();   }}><Eye   size={15}/></button>}
    {onEdit   && <button style={{ ...S.btnGhost, color:C.teal   }} title="Edit"   onClick={e=>{ e.stopPropagation(); onEdit();   }}><Edit2 size={15}/></button>}
    {onDelete && <button style={{ ...S.btnGhost, color:C.danger  }} title="Delete" onClick={e=>{ e.stopPropagation(); onDelete(); }}><Trash2 size={15}/></button>}
  </div>
);
export default ActionBtns;